import { isServerSide } from '../isServerSide'

const getNumSlices = (pclnBootstrapData) => {
  if (!isServerSide) {
    return window.PCLN_BOOTSTRAP_DATA.numSlices
  }
  return pclnBootstrapData?.numSlices
}

export { getNumSlices }
